import ProjectGroup from '../project-group';

/**
 * Create the action
 */

const { thunk, request, success, error } = ProjectGroup.index((fetch) => {
    return fetch.get('/project-groups');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
